const cookie = {};
const validKeyPattern = new RegExp('^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+\x24')  // eslint-disable-line

cookie._isValidKey = function (key) {
  return validKeyPattern.test(key);
};

cookie.setRaw = function (key, value, options) {
  if (!cookie._isValidKey(key)) {
    return;
  }
  options = options || {};
  let expires = options.expires;
  if (typeof options.expires === 'number') {
    expires = new Date();
    expires.setTime(expires.getTime() + options.expires);
  }
  document.cookie =
    key +
    '=' +
    value +
    (options.path ? '; path=' + options.path : '') +
    (expires ? '; expires=' + expires.toGMTString() : '') +
    (options.domain ? '; domain=' + options.domain : '') +
    (options.secure ? '; secure' : '');
};

cookie.getRaw = function (key) {
  if (cookie._isValidKey(key)) {
    const reg = new RegExp('(^| )' + key + '=([^;]*)(;|\x24)');
    const result = reg.exec(document.cookie);
    if (result) {
      return result[2] || null;
    }
  }
  return null;
};

cookie.get = function (key) {
  let value = cookie.getRaw(key);
  if (typeof value === 'string') {
    value = decodeURIComponent(value);
    return value;
  }
  return null;
};

cookie.set = function (key, value, options) {
  cookie.setRaw(key, encodeURIComponent(value), options);
};

cookie.remove = function (key, options) {
  options = options || {};
  options.expires = new Date(0);
  cookie.setRaw(key, '', options);
};

export default cookie;
